import userShowComponent from './user-show.component';

const userShowModule = angular.module('userShow', [
])
  .component('userShow', userShowComponent)
  .name;

export default userShowModule;
